import { Component, Input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { BreezeService } from '../../../shared/services/breeze.service';
import { ErrorService } from '../../../shared/services/error.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { HelperService } from '../../../shared/services/helper.service';
import { debounceTime, distinctUntilChanged } from 'rxjs';

import { NgOtpInputModule } from 'ng-otp-input';
@Component({
    selector: 'app-otp-dialog',
    templateUrl: './otp-dialog.component.html',
    styleUrls: ['./otp-dialog.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgOtpInputModule]
})
export class OtpDialogComponent {
  mode: 'user' | 'password' | undefined;
  countdownTimer = '';
  otpLength = 6;
  private numberRegEx = /\d+/g;
  errorMessage: any;
  isLoading: boolean = false;

  // form: FormGroup = new FormGroup({});
  inputCode = new FormControl('', [
    Validators.required,
    Validators.minLength(this.otpLength),
    Validators.pattern(this.numberRegEx),
  ]);
  @Input('email') email = '';

  constructor(
    private breezeService: BreezeService,
    private errorService: ErrorService,
    private dialogService: DialogService,
    // private fb: FormBuilder,
    private helperService: HelperService
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.breezeService.getIsLoadingListener().subscribe((isLoading) => {
      this.isLoading = isLoading;
    });

    this.helperService.startTimer(300).subscribe((countdownTimer) => {
      this.countdownTimer = countdownTimer;
    });

    this.errorService.getErrorListener().subscribe((errorMessage) => {
      this.errorMessage = errorMessage;
    });

    this.inputCode.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(500))
      .subscribe((value) => {
        this.isLoading = true;
        if (value === null || value?.length !== this.otpLength) {
          this.isLoading = false;
          return;
        }

        switch (this.mode) {
          case 'user':
            this.breezeService.verifyUser(value, this.email);
            break;
          case 'password':
            this.breezeService.verifyOTP(value);
            break;

          default:
            break;
        }
      });
  }

  close() {
    this.dialogService.closeOTPModal();
  }

  onConfirmEmail() {
    // Handles login request
    this.dialogService.closeOTPModal();
    this.dialogService.openForgotPasswordDialog();
  }
}
